<template lang="pug">
	div.container-fluid
		Formulario(@buscar="buscar()", :filtro="filtro", @nuevo="nuevo" :resultados="registros")
		Resultados(v-if="filtro.vista === 'Normal'" :registros="registros", :resumen="resumen", :resumenSemana="resumenSemana", @buscar="buscar")
		ResultadosDias(v-else-if="filtro.vista === 'Agrupada'" :registros="registros", :resumen="resumen", :resumenSemana="resumenSemana", @buscar="buscar")
		// Editor(v-if="RegistroID", :RegistroID="RegistroID", @cerrar="cierraEditor")
</template>

<script>
import Formulario from './formulario'
import Resultados from './resultados'
import ResultadosDias from './resultados-dias'
import Editor from '../editor/fichar'
import { mapGetters } from 'vuex'
export default {
	components: {
		Formulario,
		Resultados,
		ResultadosDias,
		Editor
	},
	data () {
		return {
			filtro: {
				UsuarioID: null,
				fecha: new Date(),
				tipoJornada: 'Todos',
				vista: 'Normal'
			},
			RegistroID: null,
			registros: [],
			resumen: {
				Trabajado: 0,
				Acumulado: 0,
				Consumido: 0,
				Pentiende: 0
			},
			resumenSemana: {
				Trabajado: 0,
				Acumulado: 0,
				Consumido: 0,
				Pentiende: 0
			}
		}
	},
	created () {
		this.filtro.UsuarioID = this.usuario.ID
		this.filtro.fechaInicio = this.$moment().format('YYYY-MM')
		this.filtro.fechaFin = this.$moment().format('YYYY-MM')
		this.buscar()
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		nuevo () {
			this.RegistroID = 'nuevo'
		},
		cierraEditor () {
			this.RegistroID = null
			this.buscar()
		},
		buscar () {
			const form = {
				UsuarioID: this.filtro.UsuarioID,
				fecha: this.filtro.fecha,
				tipoJornada: this.filtro.tipoJornada
			}
			this.$http.post('gestion-jornada/php/api/getRegistros.php', form)
				.then(res => {
					this.registros = res.data.registros
					this.resumen = res.data.resumen
					this.resumenSemana = res.data.resumenSemana
				})
				.catch(e => {
					this.$store.commit('alertas/error',
						{
							titulo: 'Error',
							mensaje: e.response.data.error
						})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/listados/listados.vue